export const resources = {
  th: {
    translation: {
      app: { name: 'SQI Quote & Compliance OS', thaiName: 'ระบบเสนอราคาและตรวจสอบข้อกำหนด SQI' },
      nav: {
        work: 'งาน',
        approvals: 'อนุมัติ',
        data: 'ข้อมูล',
        more: 'เพิ่มเติม',
        dashboard: 'ศูนย์งาน',
        opportunities: 'โอกาสทางการขาย',
        handoffs: 'ส่งมอบผลิต',
        ingredients: 'วัตถุดิบ',
        packaging: 'บรรจุภัณฑ์',
        regulatory: 'คลังกฎระเบียบ',
        reports: 'รายงาน',
        settings: 'ตั้งค่า',
        suppliers: 'ผู้จำหน่าย',
        processes: 'กระบวนการ',
        machines: 'เครื่องจักร',
        rooms: 'ห้องผลิต',
        'pricing-policies': 'นโยบายราคา',
      },
      common: {
        demo: 'ข้อมูลสาธิต',
        search: 'ค้นหา',
        open: 'เปิดงาน',
        customer: 'ลูกค้า',
        product: 'ผลิตภัณฑ์',
        stage: 'ขั้นตอน',
        owner: 'ผู้รับผิดชอบ',
        age: 'อายุงาน',
        nextAction: 'งานถัดไป',
        blocker: 'สิ่งติดขัด',
        status: 'สถานะ',
        quantity: 'จำนวน',
        unitPrice: 'ราคาต่อหน่วย',
        total: 'รวม',
        language: 'ภาษา',
        online: 'ออนไลน์',
        offline: 'ออฟไลน์',
        lastSync: 'ซิงก์ล่าสุด',
        pending: 'รอซิงก์',
        notApplicable: 'ไม่มี',
        all: 'ทั้งหมด',
        version: 'เวอร์ชัน',
        evidence: 'หลักฐาน',
        action: 'การดำเนินการ',
        skipToContent: 'ข้ามไปยังเนื้อหาหลัก',
      },
      status: {
        pass: 'ผ่าน',
        fail: 'ไม่ผ่าน',
        blocked: 'ถูกระงับ',
        unknown: 'ข้อมูลไม่พอ',
        review: 'ต้องทบทวน',
        review_required: 'ต้องทบทวน',
        stale: 'อาจล้าสมัย',
        accepted: 'ยอมรับแล้ว',
        approved_to_send: 'อนุมัติให้ส่ง',
        sent: 'ส่งแล้ว',
        confirmed: 'ยืนยันแล้ว',
        assumed: 'ตั้งสมมติฐาน',
        missing: 'ยังขาด',
        conflicting: 'ขัดแย้ง',
        feasible: 'ดำเนินการได้',
        feasible_with_conditions: 'ดำเนินการได้แบบมีเงื่อนไข',
        active: 'ใช้งาน',
        superseded: 'แทนที่แล้ว',
        published: 'เผยแพร่แล้ว',
        new_inquiry: 'คำขอใหม่',
        brief_in_progress: 'กำลังจัดทำบรีฟ',
        technical_review: 'ทบทวนด้านเทคนิค',
        costing: 'คำนวณต้นทุน',
        regulatory_review: 'ทบทวนข้อกำหนด',
        internal_approval: 'รออนุมัติภายใน',
        ready_to_send: 'พร้อมส่ง',
        changes_requested: 'ขอแก้ไข',
        deposit_pending: 'รอมัดจำ',
        handoff_ready: 'พร้อมส่งมอบ',
        handed_off: 'ส่งมอบแล้ว',
      },
      dashboard: {
        title: 'งานที่ต้องดำเนินการ',
        subtitle: 'จัดลำดับงานอนุมัติ ความเสี่ยง และการส่งมอบที่รออยู่',
        approvals: 'ใบเสนอราคารออนุมัติ',
        regulatory: 'รอตรวจสอบข้อกำหนด',
        changes: 'ลูกค้าขอแก้ไข',
        expiring: 'ใบเสนอราคาใกล้หมดอายุ',
        stale: 'ผลประเมินอาจล้าสมัย',
        offline: 'การแก้ไขรอซิงก์',
      },
      demoAction: {
        priceApproval: 'อนุมัติราคา',
        marginException: 'ข้อยกเว้นอัตรากำไร',
        confirmAudience: 'ยืนยันกลุ่มผู้ใช้',
        reviewClassification: 'ทบทวนการจัดประเภท',
        dailyDoseMissing: 'ข้อมูลปริมาณต่อวันไม่ครบ',
        updateBottlePrice: 'อัปเดตราคาขวด',
        supplierPriceExpired: 'ราคาผู้จำหน่ายหมดอายุ',
        followCustomer: 'ติดตามลูกค้า',
        recordDeposit: 'บันทึกมัดจำ',
        releaseHandoff: 'ปล่อยชุดส่งมอบ',
        revisePackaging: 'แก้บรรจุภัณฑ์',
      },
      opportunity: {
        title: 'โอกาสทางการขาย',
        new: 'สร้างโอกาสใหม่',
        scalp: 'เซรั่มบำรุงหนังศีรษะ 30 มล.',
        internal: 'โครงการเซรั่ม SQI-SC-26001',
        summary: 'สรุปโครงการ',
        brief: 'บรีฟผลิตภัณฑ์',
        options: 'ทางเลือกผลิตภัณฑ์',
        formula: 'สูตร',
        bom: 'BOM',
        costing: 'ต้นทุน',
        compliance: 'ข้อกำหนด',
        quotation: 'ใบเสนอราคา',
        activity: 'กิจกรรม',
        targetMarket: 'ตลาดเป้าหมาย',
        saveDraft: 'บันทึกร่าง',
        queued: 'บันทึกร่างในเครื่องและเพิ่มเข้าคิวซิงก์แล้ว',
        saveError: 'ไม่สามารถบันทึกร่างได้ กรุณาลองอีกครั้ง',
      },
      brief: {
        completeness: 'ความครบถ้วนของบรีฟ',
        confirmed: 'ยืนยันแล้ว',
        assumed: 'ตั้งสมมติฐาน',
        missing: 'ยังขาด',
        conflicting: 'ขัดแย้ง',
        review: 'ต้องตรวจสอบ',
        customerQuestions: 'คำถามสำหรับลูกค้า',
        acceptFacts: 'รับข้อมูลที่เลือก',
        factsAccepted: 'รับข้อมูลแล้ว',
        acceptedNotice: 'บันทึกข้อมูลที่เลือกไว้ในบรีฟเวอร์ชันนี้แล้ว',
      },
      workspace: {
        targetLaunch: 'วันเปิดตัวเป้าหมาย',
        risk: 'ความเสี่ยง',
        managementPriceApproval: 'อนุมัติราคาจากฝ่ายบริหาร',
        moqExposure: 'จำนวน 3,000 ชิ้นมีภาระสินค้าคงเหลือจาก MOQ บรรจุภัณฑ์',
        briefReviewed: 'ทบทวนบรีฟแล้ว',
        formulaReviewed: 'ทบทวนสูตรแล้ว',
        managementApproval: 'อนุมัติจากฝ่ายบริหาร',
        customerProposal: 'ข้อเสนอสำหรับลูกค้า',
        productFormat: 'รูปแบบผลิตภัณฑ์',
        scalpSerum: 'เซรั่มหนังศีรษะ',
        packSize: 'ขนาดบรรจุ',
        desiredClaim: 'ข้อความกล่าวอ้างที่ต้องการ',
        activeConcentration: 'ความเข้มข้นสารสำคัญ',
        targetPh: 'ค่า pH เป้าหมาย',
        pregnancyPositioning: 'การวางตำแหน่งสำหรับหญิงตั้งครรภ์',
        completeness: 'เวอร์ชัน {{version}} · ครบถ้วน {{percent}}%',
        confirmConcentration: 'กรุณายืนยันความเข้มข้นของสารสำคัญ',
        confirmPregnancy: 'ต้องการวางตำแหน่งผลิตภัณฑ์สำหรับสตรีมีครรภ์หรือไม่',
        optionEssential: 'เอสเซนเชียล',
        optionPremium: 'พรีเมียม',
        optionHero: 'ฮีโร่',
        variantFormula: 'ดัดแปลงจากสูตรที่อนุมัติแล้ว',
        newDevelopment: 'พัฒนาสูตรใหม่',
        experimental: 'การพัฒนาทดลองที่มีความเสี่ยงสูง',
        weeks: '{{range}} สัปดาห์',
        driversEssential: 'MOQ ขวดและสารสำคัญ',
        driversPremium: 'ความคงตัวและขวดแก้วพรีเมียม',
        driversHero: 'หลักฐานคำกล่าวอ้างและ assay ของสารสำคัญ',
        formulaSource: 'ที่มาสูตร',
        leadTime: 'ระยะเวลาดำเนินการ',
        costDrivers: 'ตัวกำหนดต้นทุนหลัก',
        formulaBasis: 'ร้อยละโดยน้ำหนัก · เป้าหมาย 100 กก. · yield 98%',
        phase: 'เฟส',
        ingredient: 'วัตถุดิบ',
        versionLabel: '{{name}} · เวอร์ชัน {{version}}',
        type: 'ประเภท',
        component: 'ส่วนประกอบ',
        requirement: 'ปริมาณที่ต้องใช้',
        snapshotLabel: 'สแนปช็อต CS-26001-v3 · เอนจิน 1.0.0 · THB',
        costPerUnit: 'ต้นทุนต่อชิ้น',
        independentTiers:
          'แต่ละระดับจำนวนคำนวณ MOQ การปัดเศษแพ็ก จำนวนแบตช์ และการกระจายต้นทุนคงที่แยกจากกัน',
        assessmentLabel: 'ผลประเมิน RA-26001-v2 · ชุดกฎ DEMO-2026.08',
        reasonMissing: 'ข้อมูลที่จำเป็นยังไม่ครบ จึงให้ผลเป็นข้อมูลไม่พอ',
        reasonCondition: 'เงื่อนไขของกฎตรงกับข้อมูลที่ประเมิน',
        regulatoryAction: 'ให้ผู้ทบทวนด้านข้อกำหนดตรวจสอบข้อมูลสาธิตนี้',
        pack: 'บรรจุภัณฑ์',
        packDescription: 'ขวดแก้วสีชา 30 มล. + หลอดหยด + กล่อง',
        terms: 'เงื่อนไข',
        termsDescription: 'มัดจำ 50% · ชำระส่วนที่เหลือก่อนส่งมอบ',
        units: '{{count}} ชิ้น',
        perUnit: 'ต่อชิ้น',
        eventApproval: 'ส่งคำขออนุมัติฝ่ายบริหาร',
        eventRegulatory: 'ทบทวนผลประเมินข้อกำหนดแล้ว',
        eventClaim: 'แก้ข้อความกล่าวอ้างให้มีความเสี่ยงต่ำลง',
        eventCost: 'คำนวณสแนปช็อตต้นทุน v3',
        eventFormula: 'ทบทวนสูตร v3 เพื่อคำนวณต้นทุน',
        system: 'ระบบ',
      },
      formula: {
        title: 'สูตรเวอร์ชัน 3',
        approved: 'ทบทวนเพื่อคำนวณต้นทุนแล้ว',
        net: 'ปริมาณสุทธิ',
        gross: 'ปริมาณผลิตจริง',
        sum: 'รวมสูตร',
      },
      costing: {
        title: 'เปรียบเทียบต้นทุนตามจำนวน',
        fixed: 'ต้นทุนคงที่',
        variable: 'ต้นทุนผันแปร',
        moq: 'ภาระ MOQ',
        margin: 'อัตรากำไร',
        driver: 'ตัวกำหนดราคา',
      },
      compliance: {
        title: 'ผลตรวจสอบข้อกำหนดเบื้องต้น',
        caveat: 'DEMO — NOT FOR REGULATORY USE — ไม่ใช่ข้อมูลสำหรับใช้ยื่นจริง',
        pass: 'ผ่าน',
        fail: 'ไม่ผ่าน',
        review: 'ต้องทบทวน',
        unknown: 'ข้อมูลไม่พอ',
        stale: 'อาจล้าสมัย',
        source: 'แหล่งอ้างอิง',
        disclaimer:
          'เอกสารนี้เป็นการตรวจสอบเบื้องต้นภายในองค์กร ไม่ใช่การอนุมัติจากหน่วยงานรัฐ ความเห็นทางกฎหมาย หรือการทดแทนการตรวจสอบโดยผู้รับผิดชอบด้านกฎหมายและทะเบียนผลิตภัณฑ์',
      },
      quotation: {
        title: 'ใบเสนอราคาเวอร์ชัน 3',
        approved: 'อนุมัติให้ส่งแล้ว',
        validity: 'ใช้ได้ถึง',
        selectTier: 'เลือกระดับจำนวน',
        accept: 'ยอมรับข้อเสนอ',
        requestChanges: 'ขอแก้ไข',
        publicNotice: 'การยอมรับข้อเสนอเชิงพาณิชย์ ไม่ใช่ลายมือชื่ออิเล็กทรอนิกส์',
      },
      publicProposal: {
        loading: 'กำลังโหลดข้อเสนอ…',
        unavailableTitle: 'ไม่พบข้อเสนอ',
        unavailableBody: 'ลิงก์นี้อาจหมดอายุ ถูกยกเลิก หรือไม่ถูกต้อง',
        documentLabel: 'ข้อเสนอเชิงพาณิชย์ · {{id}} v{{version}}',
        preparedFor: 'จัดทำสำหรับ {{customer}}',
        validUntil: 'ข้อเสนอใช้ได้ถึง {{date}}',
        productConcept: 'แนวคิดผลิตภัณฑ์',
        conceptDescription:
          'เซรั่มบำรุงหนังศีรษะแบบไม่ต้องล้างออก เนื้อบางเบา บรรจุขวดแก้วสีชา 30 มล. พร้อมหลอดหยดและกล่องพิมพ์',
        units: '{{count}} ชิ้น',
        perUnit: '{{price}} / ชิ้น',
        name: 'ชื่อผู้ตอบ',
        role: 'ตำแหน่ง (ไม่บังคับ)',
        comment: 'ความคิดเห็น',
        download: 'ดาวน์โหลด PDF',
        accepted: 'บันทึกการยอมรับข้อเสนอแล้ว',
        changesRecorded: 'บันทึกคำขอแก้ไขแล้ว',
      },
      approvals: { title: 'คิวอนุมัติ', versionBound: 'การอนุมัติผูกกับเวอร์ชันและแฮชข้อมูล' },
      handoffs: { title: 'ชุดส่งมอบการผลิต', immutable: 'ชุดที่ปล่อยสู่การผลิตแล้วแก้ไขไม่ได้' },
      master: { title: 'ข้อมูลหลัก', currentVersion: 'ข้อมูลราคาจะสร้างเวอร์ชันใหม่เสมอ' },
      regulatory: {
        title: 'คลังกฎและแหล่งอ้างอิง',
        demoOnly: 'รุ่นสาธิตนี้ไม่มีแหล่งกฎทางการสำหรับใช้งานจริง',
        changeAlert: 'การเปลี่ยนแปลงแหล่งข้อมูล',
      },
      reports: {
        title: 'รายงานและเอกสาร',
        generate: 'สร้างเอกสาร',
        confidential: 'เอกสารภายใน — ลับ',
        customerSafe: 'สำหรับลูกค้า',
        kind: {
          customerQuotation: 'ใบเสนอราคาสำหรับลูกค้า PDF',
          internalCosting: 'รายงานต้นทุนภายใน',
          formulaBom: 'รายงานสูตรและ BOM',
          regulatoryPreflight: 'รายงานตรวจสอบข้อกำหนดเบื้องต้น',
          labelPreflight: 'รายงานตรวจฉลากเบื้องต้น',
          approvalHistory: 'รายงานประวัติการอนุมัติ',
          productionHandoff: 'รายงานส่งมอบการผลิต',
          regulatoryDossier: 'ชุดเอกสารข้อกำหนด ZIP',
          auditSnapshot: 'สแนปช็อตตรวจสอบ JSON',
        },
      },
      settings: {
        title: 'การตั้งค่าองค์กร',
        organization: 'SQI Demo Manufacturing',
        role: 'เจ้าของ / ผู้ดูแลระบบ',
        users: 'ผู้ใช้และสิทธิ์',
        offline: 'การใช้งานออฟไลน์',
        logout: 'ออกจากระบบและล้างข้อมูลออฟไลน์',
      },
      login: {
        title: 'เข้าสู่ระบบ',
        demo: 'เข้าสู่โหมดสาธิต',
        email: 'อีเมล',
        password: 'รหัสผ่าน',
        submit: 'เข้าสู่ระบบ',
        localOnly: 'ข้อมูลสาธิต · ไม่มีการเก็บข้อมูลรับรองสำหรับระบบจริง',
      },
      offline: {
        draft: 'OFFLINE DRAFT',
        restriction: 'การดำเนินการนี้ต้องเชื่อมต่ออินเทอร์เน็ตและตรวจสอบสิทธิ์บนเซิร์ฟเวอร์',
      },
      collection: {
        code: 'รหัส',
        name: 'ชื่อ',
        basis: 'หน่วย/เกณฑ์',
        record: 'รายการ',
        management: 'ฝ่ายบริหาร',
        requestedAgo: 'ขออนุมัติเมื่อ {{hours}} ชม. ที่แล้ว',
        marginException: 'ข้อยกเว้นอัตรากำไร',
        marginComparison: '32.8% เทียบเป้าหมาย 35%',
        review: 'ทบทวน',
        reviewExactVersion: 'ทบทวนเวอร์ชันและแฮชที่ระบุ',
        decisionReason: 'เหตุผลการตัดสินใจ',
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ',
        approved: 'บันทึกการอนุมัติเวอร์ชันนี้แล้ว',
        rejected: 'บันทึกการไม่อนุมัติเวอร์ชันนี้แล้ว',
        facialMask: 'มาสก์หน้าแบบซอง',
        acceptedQuote: 'ใบเสนอราคา QT-26003 v2 ที่ยอมรับแล้ว',
        formulaVersion: 'สูตร F-031 v4',
        bomVersion: 'BOM v2',
        assessmentVersion: 'ผลประเมิน RA-26003 v1',
        depositConfirmed: 'ยืนยันมัดจำแล้ว',
        labelRisk: 'ความเสี่ยงจากการตรวจฉลากยังเปิดอยู่',
        demoUsers: 'ผู้ใช้สาธิต 7 คน · ชุดสิทธิ์แบบระบุชัด · จำกัดขอบเขตตามองค์กรที่ใช้งาน',
        defaultLanguage: 'ภาษาเริ่มต้น',
        currency: 'สกุลเงิน',
        formulaTolerance: 'ค่าคลาดเคลื่อนสูตร',
        timeZone: 'เขตเวลา',
        section: {
          sources: 'แหล่งอ้างอิง',
          rules: 'กฎ',
          claims: 'ข้อความกล่าวอ้าง',
          labels: 'ฉลาก',
          facilities: 'สถานที่ผลิต',
          tests: 'การทดสอบ',
          'change-alerts': 'แจ้งเตือนการเปลี่ยนแปลง',
        },
      },
      offlineSettings: {
        cachedRuleSet: 'ชุดกฎที่แคช',
        cachedPriceDate: 'วันที่ราคาที่แคช',
        syncNow: 'ซิงก์คิวสาธิต',
        demonstrateConflict: 'สาธิตความขัดแย้ง',
        syncResult: 'ซิงก์สำเร็จ {{count}} รายการ',
        localDraftValue: 'ค่าร่างจากอุปกรณ์นี้',
        serverValue: 'ค่าจากเซิร์ฟเวอร์เวอร์ชันใหม่กว่า',
        conflictCreated: 'สร้างความขัดแย้งสาธิตแล้ว',
        conflictTitle: 'พบความขัดแย้งของเวอร์ชัน',
        conflictDescription:
          'ร่างในเครื่องเริ่มจาก v{{local}} แต่เซิร์ฟเวอร์เป็น v{{server}} ระบบจะไม่เขียนทับอัตโนมัติ',
        keepServer: 'ใช้ข้อมูลเซิร์ฟเวอร์',
        branchLocal: 'บันทึกร่างเป็นเวอร์ชันใหม่',
        localBranched: 'เก็บร่างในเครื่องเป็นรายการซิงก์เวอร์ชันใหม่แล้ว',
        serverKept: 'เลือกใช้ข้อมูลจากเซิร์ฟเวอร์แล้ว',
      },
      pwa: {
        updateAvailable: 'มีเวอร์ชันใหม่พร้อมใช้งาน',
        offlineReady: 'แอปพร้อมใช้งานแบบออฟไลน์แล้ว',
        pendingBlocksUpdate: 'ต้องซิงก์รายการที่ค้างอยู่ก่อนอัปเดตแอป',
        update: 'อัปเดต',
        dismiss: 'ปิด',
      },
    },
  },
  en: {
    translation: {
      app: { name: 'SQI Quote & Compliance OS', thaiName: 'SQI quotation and compliance system' },
      nav: {
        work: 'Work',
        approvals: 'Approvals',
        data: 'Data',
        more: 'More',
        dashboard: 'Action center',
        opportunities: 'Opportunities',
        handoffs: 'Handoffs',
        ingredients: 'Ingredients',
        packaging: 'Packaging',
        regulatory: 'Regulatory library',
        reports: 'Reports',
        settings: 'Settings',
        suppliers: 'Suppliers',
        processes: 'Processes',
        machines: 'Machines',
        rooms: 'Rooms',
        'pricing-policies': 'Pricing policies',
      },
      common: {
        demo: 'Demo data',
        search: 'Search',
        open: 'Open',
        customer: 'Customer',
        product: 'Product',
        stage: 'Stage',
        owner: 'Owner',
        age: 'Age',
        nextAction: 'Next action',
        blocker: 'Blocker',
        status: 'Status',
        quantity: 'Quantity',
        unitPrice: 'Unit price',
        total: 'Total',
        language: 'Language',
        online: 'Online',
        offline: 'Offline',
        lastSync: 'Last sync',
        pending: 'Pending sync',
        notApplicable: 'None',
        all: 'All',
        version: 'Version',
        evidence: 'Evidence',
        action: 'Action',
        skipToContent: 'Skip to main content',
      },
      status: {
        pass: 'Pass',
        fail: 'Fail',
        blocked: 'Blocked',
        unknown: 'Unknown',
        review: 'Review',
        review_required: 'Review required',
        stale: 'Stale',
        accepted: 'Accepted',
        approved_to_send: 'Approved to send',
        sent: 'Sent',
        confirmed: 'Confirmed',
        assumed: 'Assumed',
        missing: 'Missing',
        conflicting: 'Conflicting',
        feasible: 'Feasible',
        feasible_with_conditions: 'Feasible with conditions',
        active: 'Active',
        superseded: 'Superseded',
        published: 'Published',
        new_inquiry: 'New inquiry',
        brief_in_progress: 'Brief in progress',
        technical_review: 'Technical review',
        costing: 'Costing',
        regulatory_review: 'Regulatory review',
        internal_approval: 'Internal approval',
        ready_to_send: 'Ready to send',
        changes_requested: 'Changes requested',
        deposit_pending: 'Deposit pending',
        handoff_ready: 'Handoff ready',
        handed_off: 'Handed off',
      },
      dashboard: {
        title: 'Work requiring action',
        subtitle: 'Prioritized approvals, risks and handoffs',
        approvals: 'Quotes awaiting approval',
        regulatory: 'Regulatory reviews',
        changes: 'Customer changes',
        expiring: 'Quotes expiring',
        stale: 'Potentially stale assessments',
        offline: 'Offline changes',
      },
      demoAction: {
        priceApproval: 'Approve price',
        marginException: 'Margin exception',
        confirmAudience: 'Confirm target audience',
        reviewClassification: 'Review classification',
        dailyDoseMissing: 'Daily-dose data is missing',
        updateBottlePrice: 'Update bottle price',
        supplierPriceExpired: 'Supplier price expired',
        followCustomer: 'Follow up with customer',
        recordDeposit: 'Record deposit',
        releaseHandoff: 'Release handoff',
        revisePackaging: 'Revise packaging',
      },
      opportunity: {
        title: 'Opportunities',
        new: 'New opportunity',
        scalp: '30 mL scalp serum',
        internal: 'SQI-SC-26001 serum project',
        summary: 'Project summary',
        brief: 'Product brief',
        options: 'Product options',
        formula: 'Formula',
        bom: 'BOM',
        costing: 'Costing',
        compliance: 'Compliance',
        quotation: 'Quotation',
        activity: 'Activity',
        targetMarket: 'Target market',
        saveDraft: 'Save draft',
        queued: 'Draft saved locally and added to the sync queue.',
        saveError: 'The draft could not be saved. Please try again.',
      },
      brief: {
        completeness: 'Brief completeness',
        confirmed: 'Confirmed',
        assumed: 'Assumed',
        missing: 'Missing',
        conflicting: 'Conflicting',
        review: 'Needs review',
        customerQuestions: 'Customer questions',
        acceptFacts: 'Accept selected facts',
        factsAccepted: 'Facts accepted',
        acceptedNotice: 'The selected facts were saved to this brief version.',
      },
      workspace: {
        targetLaunch: 'Target launch',
        risk: 'Risk',
        managementPriceApproval: 'Management price approval',
        moqExposure: 'The 3,000-unit packaging MOQ creates inventory exposure.',
        briefReviewed: 'Brief reviewed',
        formulaReviewed: 'Formula reviewed',
        managementApproval: 'Management approval',
        customerProposal: 'Customer proposal',
        productFormat: 'Product format',
        scalpSerum: 'Scalp serum',
        packSize: 'Pack size',
        desiredClaim: 'Desired claim',
        activeConcentration: 'Active concentration',
        targetPh: 'Target pH',
        pregnancyPositioning: 'Pregnancy positioning',
        completeness: 'Version {{version}} · {{percent}}% complete',
        confirmConcentration: 'Please confirm the active concentration.',
        confirmPregnancy: 'Will the product be positioned for pregnancy use?',
        optionEssential: 'Essential',
        optionPremium: 'Premium',
        optionHero: 'Hero',
        variantFormula: 'Variant of approved formula',
        newDevelopment: 'New development',
        experimental: 'Experimental high-risk development',
        weeks: '{{range}} weeks',
        driversEssential: 'Bottle MOQ and active ingredient',
        driversPremium: 'Stability and premium glass',
        driversHero: 'Claim evidence and active assay',
        formulaSource: 'Formula source',
        leadTime: 'Lead time',
        costDrivers: 'Main cost drivers',
        formulaBasis: 'Weight percentage · target 100 kg · yield 98%',
        phase: 'Phase',
        ingredient: 'Ingredient',
        versionLabel: '{{name}} · Version {{version}}',
        type: 'Type',
        component: 'Component',
        requirement: 'Requirement',
        snapshotLabel: 'Snapshot CS-26001-v3 · engine 1.0.0 · THB',
        costPerUnit: 'Cost / unit',
        independentTiers:
          'Each tier independently recalculates MOQ, pack rounding, batches, and fixed-cost allocation.',
        assessmentLabel: 'Assessment RA-26001-v2 · rule set DEMO-2026.08',
        reasonMissing: 'Required information is missing, so the result is unknown.',
        reasonCondition: 'The rule condition matched the assessed facts.',
        regulatoryAction: 'A named regulatory reviewer must verify this demonstration finding.',
        pack: 'Pack',
        packDescription: '30 mL amber glass bottle + dropper + carton',
        terms: 'Terms',
        termsDescription: '50% deposit · balance before delivery',
        units: '{{count}} units',
        perUnit: 'per unit',
        eventApproval: 'Management approval requested',
        eventRegulatory: 'Regulatory assessment reviewed',
        eventClaim: 'Claim changed to lower-risk wording',
        eventCost: 'Cost snapshot v3 calculated',
        eventFormula: 'Formula v3 reviewed for costing',
        system: 'System',
      },
      formula: {
        title: 'Formula version 3',
        approved: 'Reviewed for costing',
        net: 'Net requirement',
        gross: 'Gross manufacturing',
        sum: 'Formula total',
      },
      costing: {
        title: 'Quantity-tier economics',
        fixed: 'Fixed cost',
        variable: 'Variable cost',
        moq: 'MOQ exposure',
        margin: 'Gross margin',
        driver: 'Price constraint',
      },
      compliance: {
        title: 'Regulatory preflight',
        caveat: 'DEMO — NOT FOR REGULATORY USE — ไม่ใช่ข้อมูลสำหรับใช้ยื่นจริง',
        pass: 'Pass',
        fail: 'Fail',
        review: 'Review',
        unknown: 'Unknown',
        stale: 'Stale',
        source: 'Source',
        disclaimer:
          'Internal regulatory preflight only. This document is not an official approval, legal opinion, or substitute for review by an authorized regulatory professional.',
      },
      quotation: {
        title: 'Quotation version 3',
        approved: 'Approved to send',
        validity: 'Valid until',
        selectTier: 'Select quantity tier',
        accept: 'Accept proposal',
        requestChanges: 'Request changes',
        publicNotice: 'Commercial proposal acceptance; not an electronic-signature claim.',
      },
      publicProposal: {
        loading: 'Loading proposal…',
        unavailableTitle: 'Proposal unavailable',
        unavailableBody: 'This link may be expired, revoked, or invalid.',
        documentLabel: 'Commercial proposal · {{id}} v{{version}}',
        preparedFor: 'Prepared for {{customer}}',
        validUntil: 'Valid until {{date}}',
        productConcept: 'Product concept',
        conceptDescription:
          'Lightweight leave-on scalp serum in a 30 mL amber glass bottle with dropper and printed carton.',
        units: '{{count}} units',
        perUnit: '{{price}} / unit',
        name: 'Name',
        role: 'Role / title (optional)',
        comment: 'Comment',
        download: 'Download PDF',
        accepted: 'Proposal acceptance recorded.',
        changesRecorded: 'Change request recorded.',
      },
      approvals: {
        title: 'Approval queue',
        versionBound: 'Approvals are bound to the exact version and input hash.',
      },
      handoffs: { title: 'Production handoffs', immutable: 'Released handoffs are immutable.' },
      master: {
        title: 'Master data',
        currentVersion: 'Price updates always create a new version.',
      },
      regulatory: {
        title: 'Rules and source library',
        demoOnly: 'This demo contains no official production regulatory sources.',
        changeAlert: 'Source change alert',
      },
      reports: {
        title: 'Reports and documents',
        generate: 'Generate',
        confidential: 'Internal document — confidential',
        customerSafe: 'Customer-safe',
        kind: {
          customerQuotation: 'Customer quotation PDF',
          internalCosting: 'Internal costing report',
          formulaBom: 'Formula and BOM report',
          regulatoryPreflight: 'Regulatory preflight report',
          labelPreflight: 'Label preflight report',
          approvalHistory: 'Approval history report',
          productionHandoff: 'Production handoff report',
          regulatoryDossier: 'Regulatory dossier ZIP',
          auditSnapshot: 'JSON audit snapshot',
        },
      },
      settings: {
        title: 'Organization settings',
        organization: 'SQI Demo Manufacturing',
        role: 'Owner / Administrator',
        users: 'Users and permissions',
        offline: 'Offline settings',
        logout: 'Sign out and clear offline data',
      },
      login: {
        title: 'Sign in',
        demo: 'Enter demo mode',
        email: 'Email',
        password: 'Password',
        submit: 'Sign in',
        localOnly: 'Demo data · no production credentials are stored',
      },
      offline: {
        draft: 'OFFLINE DRAFT',
        restriction: 'This action requires a server connection and online permission check.',
      },
      collection: {
        code: 'Code',
        name: 'Name',
        basis: 'Basis',
        record: 'Record',
        management: 'Management',
        requestedAgo: 'Requested {{hours}}h ago',
        marginException: 'Margin exception',
        marginComparison: '32.8% vs 35% target',
        review: 'Review',
        reviewExactVersion: 'Review the exact version and input hash',
        decisionReason: 'Decision reason',
        approve: 'Approve',
        reject: 'Reject',
        approved: 'Approval recorded for this version.',
        rejected: 'Rejection recorded for this version.',
        facialMask: 'Facial mask sachet',
        acceptedQuote: 'Accepted quote QT-26003 v2',
        formulaVersion: 'Formula F-031 v4',
        bomVersion: 'BOM v2',
        assessmentVersion: 'Regulatory assessment RA-26003 v1',
        depositConfirmed: 'Deposit confirmed',
        labelRisk: 'Label review risk remains open',
        demoUsers: '7 demo users · explicit permission bundles · active organization scope',
        defaultLanguage: 'Default language',
        currency: 'Currency',
        formulaTolerance: 'Formula tolerance',
        timeZone: 'Time zone',
        section: {
          sources: 'Sources',
          rules: 'Rules',
          claims: 'Claims',
          labels: 'Labels',
          facilities: 'Facilities',
          tests: 'Tests',
          'change-alerts': 'Change alerts',
        },
      },
      offlineSettings: {
        cachedRuleSet: 'Cached rule set',
        cachedPriceDate: 'Cached price date',
        syncNow: 'Sync demo queue',
        demonstrateConflict: 'Demonstrate conflict',
        syncResult: '{{count}} queued changes synchronized',
        localDraftValue: 'Draft value from this device',
        serverValue: 'Newer server value',
        conflictCreated: 'Demo conflict created.',
        conflictTitle: 'Version conflict detected',
        conflictDescription:
          'The local draft started from v{{local}}, but the server is now v{{server}}. It will not be overwritten silently.',
        keepServer: 'Keep server',
        branchLocal: 'Save local as new version',
        localBranched: 'The local draft was queued as a new version.',
        serverKept: 'The server value was retained.',
      },
      pwa: {
        updateAvailable: 'A new version is ready.',
        offlineReady: 'The app is ready for offline use.',
        pendingBlocksUpdate: 'Sync pending changes before updating the app.',
        update: 'Update',
        dismiss: 'Dismiss',
      },
    },
  },
} as const;
